<div class="content">

    <div class="text-left mt-5">

        <h3>Get Job Status on WebSocket</h3> <br>
     
        <p>Connect to Websocket and get the Job status</p>
    
        <div class="card text-bg-dark mb-3">
            <div class="card-body">

                <div class="card-title">
                    <button style="float: right;" *ngIf="copyButton" class="btn btn-outline-primary btn-sm" (click)="copyJsonToClipboard()">
                      <i class="fa fa-clipboard" aria-hidden="true"></i>
                    </button>
                      
                    <button style="float: right;" *ngIf="copiedButton"  class="btn btn-success btn-sm">
                      Copied <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
              
                   </div><br><br>

                <pre><code [innerHTML]="jsonData" ></code></pre>
            </div>
        </div><br><br>


        <h4>Websocket Sample Code</h4><br>

        <div class="card text-bg-dark mb-3">
            <div class="card-body">
                <pre><code [innerHTML]="websocketData"></code></pre>
            </div>
        </div>
        
    
    </div>

</div>


